import React from 'react';
import { string, number } from 'prop-types';
import { inchesToPxs } from '../../../../utils/wall-size-utils';

function segmentToScreen(segment, pxInInches) {
  if (!segment) {
    return null;
  }

  const {
    left, top, width, height, ...other
  } = segment;

  return {
    ...other,
    left: inchesToPxs(left, pxInInches),
    top: inchesToPxs(top, pxInInches),
    width: inchesToPxs(width, pxInInches),
    height: inchesToPxs(height, pxInInches)
  };
}

export const Segment = ({
  left, top, width, height, type, pxInInches
}) => {

  const convertedSeg = segmentToScreen({
    left, top, width, height, type
  }, pxInInches);

  if (!convertedSeg) {
    return null;
  }

  return (
    <div
      className="segment"
      style={{
        left: convertedSeg.left,
        top: convertedSeg.top,
        width: convertedSeg.width,
        height: convertedSeg.height,
      }}
    >
      <div>{type?.toLocaleUpperCase()}</div>
    </div>
  );
};

Segment.propTypes = {
  left: number,
  top: number,
  width: number,
  height: number,
  type: string,
  pxInInches: number
};

Segment.defaultProps = {
  left: 0,
  top: 0,
  width: 0,
  height: 0,
  type: '',
  pxInInches: 1
};